export var RP_ANALYTICS_BASE_URL = '/api/rpj/v1/rp_analytics';